import request from '../utils/request'
import type { OrgCompany, OrgDepartment, OrgEmployee } from '../types/models'
import type { PageResult } from '../utils/request'

export function getCompanyList() {
  return request.get<OrgCompany[]>('/base/org/company/list')
}

export function saveCompany(data: Partial<OrgCompany>) {
  if (data.id) {
    return request.put<OrgCompany>(`/base/org/company/${data.id}`, data)
  }
  return request.post<OrgCompany>('/base/org/company', data)
}

export function deleteCompany(id: string | number) {
  return request.delete<boolean>(`/base/org/company/${id}`)
}

export function getDepartmentList() {
  return request.get<OrgDepartment[]>('/base/org/department/list')
}

export function saveDepartment(data: Partial<OrgDepartment>) {
  if (data.id) {
    return request.put<OrgDepartment>(`/base/org/department/${data.id}`, data)
  }
  return request.post<OrgDepartment>('/base/org/department', data)
}

export function deleteDepartment(id: string | number) {
  return request.delete<boolean>(`/base/org/department/${id}`)
}

export function getOrgEmployeeList(params?: {
  pageNum?: number
  pageSize?: number
  keyword?: string
  departmentId?: string
  status?: number
  positionCategory?: string
}) {
  return request.get<PageResult<OrgEmployee>>('/base/org/employee/list', { params })
}

export function getOrgEmployeeAll(params?: {
  status?: number
  positionCategory?: string
}) {
  return request.get<OrgEmployee[]>('/base/org/employee/all', { params })
}

export function getOrgEmployeeById(id: string | number) {
  return request.get<OrgEmployee>(`/base/org/employee/${id}`)
}

export function getCurrentOrgEmployee() {
  return request.get<OrgEmployee | null>('/base/org/employee/current')
}

export function createOrgEmployee(data: Partial<OrgEmployee>) {
  return request.post<OrgEmployee>('/base/org/employee', data)
}

export function updateOrgEmployee(id: string | number, data: Partial<OrgEmployee>) {
  return request.put<OrgEmployee>(`/base/org/employee/${id}`, data)
}

export function deleteOrgEmployee(id: string | number) {
  return request.delete<boolean>(`/base/org/employee/${id}`)
}

export function bindOrgEmployeeUser(data: {
  employeeId: string | number
  userId: string | number
}) {
  return request.post<boolean>('/base/org/employee/bind-user', data)
}
